module.exports = __webpack_public_path__ + "img/gem.1f338981.svg";